<template>
  <v-dialog
    ref="dialog"
    v-model="modaldate"
    :close-on-content-click="false"
    persistent
    width="300px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        v-bind="attrs"
        :append-icon="appen ? 'mdi-calendar-multiple-check' : ''"
        :prepend-icon="!appen ? 'mdi-calendar-multiple-check' : ''"
        :label="label"
        color="primary"
        :outlined="outlined"
        dense
        readonly
        :class="{ 'search-input': hideDetails }"
        v-on="on"
      />
    </template>
    <v-date-picker v-model="dates" range v-bind="options" color="primary">
      <v-col>
        <ButtonCancel @click="modaldate = false" />
      </v-col>
      <v-col>
        <ButtonSuccess
          @click="
            $refs.dialog.save(dates),
              $emit('input', dates),
              $emit('click', false)
          "
        />
      </v-col>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
  name: "DatePickerRange",
  props: {
    mindate: {
      type: String,
      default: "false",
    },
    maxdate: {
      type: String,
      default: "false",
    },
    label: {
      type: String,
      default: "Date Range",
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    start: {
      type: Number,
      default: 0,
    },
    appen: {
      type: Boolean,
      default: true,
    },
    currentRange: {
      type: Array,
      default: null,
    },
  },
  data() {
    const self = this;
    return {
      modaldate: false,
      dates: [
        self.$appFormatters.getTodayMinusDays(this.start),
        self.$appFormatters.formatDateDB(new Date()),
      ],
      /* options: {}, */
    };
  },

  computed: {
    dateRangeText: {
      get() {
        return (
          this.$appFormatters.formatDateRange(this.dates[0]) +
          " - " +
          this.$appFormatters.formatDateRange(this.dates[1])
        );
      },
      set(val) {
        return val;
      },
    },
    options() {
      return {
        max: this.maxdate == "false" ? "" : this.maxdate,
        min: this.mindate == "false" ? "" : this.mindate,
      };
    },
  },
  watch: {
    dates(value) {
      //Valid that the second value is bigger that bhe first one
      if (value.length === 2) {
        if (value[1] < value[0]) {
          value.splice(0, 1);
        }
      }
    },
    currentRange(value) {
      //Valid that the second value is bigger that bhe first one
      if (value.length > 0) {
        this.dates = this.currentRange;
      }
    },
  },
  mounted() {
    //add min date propety if there is a value

    this.$emit("input", this.dates);
  },
};
</script>
